const filter = { items: [] }

export default filter
